// extracted by mini-css-extract-plugin
export default {"form":"BasicInfo_form__8Sq9n","group":"BasicInfo_group__R1UiF"};